import React, { useEffect, useState } from "react";
// import ImageAbout from "../../../assets/images/about.png";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import API_URL from "../../../config/constant";
import LogoAbout from "../../../assets/images/logo-about.png";

export default function About() {
    const { t } = useTranslation();
    const [aboutData, setAboutData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);
    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                // eslint-disable-next-line no-undef
                const response = await fetch(`${API_URL}/home?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const data = await response.json();
                if (data.about === null) {
                    throw new Error("Data not found");
                }
                setAboutData(data.about);
            } catch (error) {
                setAboutData(t("home.about", { returnObjects: true }));
            }
        };

        fetchAboutData();
    }, [t, locale]);
    return (
        <>
            {/* WILL BE ENABLED SOON */}
            {/* <div className="bg-registerHere min-h-96 bg-no-repeat bg-cover bg-center h-full font-evil flex justify-center items-center">
                <div className="text-center bg-[#164481] shadow-md cursor-pointer hover:shadow-2xl duration-300">
                    <p className="text-6xl xl:text-7xl 2xl:text-8xl text-white px-8 py-2">REGISTER HERE</p>
                </div>
            </div> */}
            <div className="bg-white md:bg-aboutTheEvent bg-no-repeat bg-cover bg-top relative font-evil min-h-screen flex items-center justify-center">
                <div className="relative min-h-full h-full text-white bg-brand-orange border-t-2 border-brand-orange border-b px-6">
                    <div className="absolute -top-5 left-1/2 -translate-x-1/2">
                        <div className="bg-brand-blue shadow-2xl inline-block px-8 py-2">
                            <p className="text-5xl 2xl:text-7xl text-white">
                                {aboutData?.title}
                            </p>
                        </div>
                    </div>
                    <div className="pt-16 place-content-center w-full pb-8 uppercase basis-full flex justify-center">
                        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-6 max-w-[75vw] lg:max-w-[80vw]">
                            {/* <div className="flex-shrink-0 items-center flex justify-center lg:h-full items-center justify-center">
                                <img
                                    src={LogoAbout}
                                    alt="Logo"
                                    className="w-40 lg:w-40 xl:w-64"
                                />
                            </div> */}
                            <div className="flex-1 text-center lg:text-left space-y-4 normal-case font-poppins font-medium text-xs md:text-lg 2xl:text-xl">
                                <div
                                    className="space-y-4 text-center"
                                    dangerouslySetInnerHTML={{ __html: aboutData?.content }}
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
